import React, {useEffect, useRef, useState} from 'react'
import {KTIcon, KTSVG} from '../_metronic/helpers'
import {formatTypePiecePourDemande} from './helpers'

const SearchPiece = (props) => {
  const [activeSuggestionPiece, setActiveSuggestionPiece] = useState()
  const ulRef = useRef<HTMLUListElement | null>(null)
  const [showSuggestionsPiece, setShowSuggestionsPiece] = useState<boolean>(false)
  const {
    resultatPiece,
    resultShowPiece,
    clearInput,
    setSearchValue,
    handleInitialEdit,
    value,
    pieceSpinner,
    selectedSearchValue,
    setSelectedSearchValue,
    match,
    setMatch,
    showPieceHn,
    isDemontage = false,
    onSelect
  } = props
  const [focused, setFocused] = useState<boolean>(false)
  const [closeBtn, setCloseBtn] = useState<boolean>(false)
  const [pieceHn, setPieceHn] = useState<boolean>(false)

  useEffect(() => {
    if (resultatPiece) {
      setShowSuggestionsPiece(true)
      if (resultatPiece) {
        setPieceHn(true)
      }
    }
  }, [resultatPiece])

  // Affiché le bouton pour réinitialiser la valeur de l'input
  useEffect(() => {
    if (value !== '') {
      if (pieceSpinner) {
        setCloseBtn(false)
        setPieceHn(false)
      } else {
        setCloseBtn(true)
      }
    } else {
      setCloseBtn(false)
      setPieceHn(false)
      setShowSuggestionsPiece(false)
    }
    if (selectedSearchValue?.length > 0) {
      setCloseBtn(true)
      setPieceHn(false)
    }
  }, [value, pieceSpinner, selectedSearchValue])

  useEffect(() => {
    clearInput && setSearchValue('')
    // Effacer l'input si clique à l'extérieur + no loading + input avec valeur + suggestion des piece qui se montrent
    if (!focused && pieceSpinner && value.length > 0 && showSuggestionsPiece) {
      setSearchValue(value)
    }
  }, [clearInput, showSuggestionsPiece, focused, pieceSpinner])

  const onClick = (index) => {
    props.onSelect(resultatPiece[index])
    // setActiveSuggestionPiece(0)
    setShowSuggestionsPiece(false)
    if (props.handleInitialEdit) handleInitialEdit()
  }

  const onClickHn = () => {
    const resultatPiece = {
      nom: value,
      id: null,
      horsNom: true,
    }
    props.onSelect(resultatPiece)
    setShowSuggestionsPiece(false)
    if (props.handleInitialEdit) handleInitialEdit()
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ulRef.current && !ulRef.current.contains(event.target as Node)) {
        setShowSuggestionsPiece(false) // Ferme les suggestions
      }
    }

    if (showSuggestionsPiece) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [showSuggestionsPiece])

  const renderSuggestionsList = () => {
    if (showSuggestionsPiece) {
      if (resultatPiece.length) {
        return (
          <ul ref={ulRef} className={'suggestions w-100'}>
            {resultatPiece.map((res, index) => {
              let className = index === activeSuggestionPiece ? 'suggestion-active' : ''

              return (
                <li className={className} key={res.id} onClick={() => onClick(index)}>
                  {formatTypePiecePourDemande(res)}
                </li>
              )
            })}
          </ul>
        )
      } else {
        return (
          <ul
            ref={ulRef}
            className={'suggestions w-100 text-white'}
            style={{backgroundColor: '#f98893'}}
          >
            Pièce non trouvée
          </ul>
        )
      }
    }
  }
  return (
    <div className={'autocomplete-container position-relative'}>
      <input
        type='text'
        className={props.inputClassName}
        onChange={props.onChange}
        onKeyDown={props.onKeyDown}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        value={value}
        placeholder={props.placeholder}
        disabled={props.disabled}
      />
      {resultShowPiece && renderSuggestionsList()}
      {pieceSpinner && (
        <div
          className='position-absolute'
          style={{
            top: '50%',
            right: '2%',
            transform: 'translateY(-50%)',
          }}
        >
          <span
            className='spinner-border spinner-border-sm align-middle ms-2'
            style={{
              color: '#99a1b7',
              width: '17px',
              height: '17px',
            }}
          ></span>
        </div>
      )}
      {pieceHn && showPieceHn && value !== '' && (
        <div
          className='position-absolute'
          data-tooltip-id='add-tooltip'
          data-tooltip-content='Ajouter la piece hors nomenclenture'
          data-tooltip-place='top'
          style={{
            top: '50%',
            right: '4%',
            transform: 'translateY(-50%)',
          }}
        >
          <button
            type='button'
            className='btn'
            style={{
              cursor: 'pointer',
            }}
            onClick={() => onClickHn()}
          >
            <KTIcon iconName='plus' className='fs-1' />
          </button>
        </div>
      )}
      {(closeBtn && !isDemontage) && (
        <div
          className='position-absolute'
          style={{
            top: '50%',
            right: '2%',
            transform: 'translateY(-50%)',
          }}
        >
          <span
            onClick={() => {
              setSearchValue('')
              if (onSelect) onSelect()
              if (setSelectedSearchValue) setSelectedSearchValue('')
              if (props.handleInitialEdit) handleInitialEdit()
              if (setMatch) {
                // Nettoyage du champ d'autocompletion apres le clic pour nettoyer le formulaire
                setMatch([])
              }
            }}
            style={{
              cursor: 'pointer',
            }}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon svg-icon-2x' />
          </span>
        </div>
      )}
      {match && ( // si match n'est pas null affiche le texte grissé dans le formulaire
        <div
          className='position-absolute text-body-tertiary user-select-none z-1'
          style={{
            top: '0.9rem',
            left: '1.57rem',
            fontSize: '1.15rem',
            letterSpacing: '0.01rem',
            whiteSpace: 'pre',
            pointerEvents: 'none',
          }}
        >
          <span className='opacity-0'>{match[0]}</span>
          {match[1]}
        </div>
      )}
    </div>
  )
}

export {SearchPiece}
